module.exports = __webpack_public_path__ + "img/ADS_Lab.94e72fae.png";